import { z } from 'zod';

import { BookTypeEnum, LevelEnum } from '../../enums';
import { levelEnumValidator } from '../../validators';

export const BookUploadQuerySchema = z.object({
  language: z
    .string()
    .min(2, { message: 'Language code must be at least 2 characters' })
    .max(10, { message: 'Language code must be at most 10 characters' })
    .default('de')
    .describe('Book language code'),
  levels: z.preprocess(
    (val) => {
      if (typeof val === 'string' && val.length > 0) {
        return val.split(',');
      }
      return Array.isArray(val) ? val : [LevelEnum.A1];
    },
    z.array(levelEnumValidator).min(1, 'At least one level is required'),
  ),
  author: z.string().optional(),
  title: z.string().min(1).optional(),
  type: z.nativeEnum(BookTypeEnum).optional(),
});

export type IBookUploadQueryDto = z.infer<typeof BookUploadQuerySchema>;
